import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import ColourLogo from "../assets/ColourLogo.svg";

const Header = () => {
  const [isOnHero, setIsOnHero] = useState(true);

  useEffect(() => {
    const handleScroll = () => {
      setIsOnHero(window.scrollY < 80);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <header
      className={`fixed top-0 left-0 w-full z-50 transition-all duration-300 ${
        isOnHero
         ? 'bg-[#F7F7F7] text-black'
          : 'bg-white text-[#4f0594] shadow-lg'
      }`}
    >
  <div className="w-full flex items-center justify-between h-16 px-10">

  {/* Logo (left, slightly pulled out) */}
  <Link to="/" className="flex items-center ml-6">
  <img src={ColourLogo} alt="ColourLogo" className="h-10" />
</Link>

    <nav className="relative">
    <ul className="flex space-x-8 font-medium text-[#6F7DFF]">
      <li>
        <Link
          to="/about"
          onClick={() => (window.location.href = "/about")}
          className="hover:text-purple-700 transition-colors duration-200"
        >
          About Us
        </Link>
      </li>

      {/* Wise Services Dropdown */}
      <li className="relative group">
        <Link
          to="/services"
          onClick={() => (window.location.href = "/services")}
          className="hover:text-purple-700 transition-colors duration-200"
        >
          Wise Services
        </Link>
        <ul
          className="absolute left-0 mt-2 w-48 bg-white text-black rounded shadow-lg opacity-0 invisible 
                     group-hover:opacity-100 group-hover:visible transition-all duration-200"
        >
          <li>
            <Link
              to="/analysis"
              onClick={() => (window.location.href = "/analysis")}
              className="block px-4 py-2 hover:bg-gray-100 hover:text-purple-700"
            >
             Image Analysis
            </Link>
          </li>
          <li>
            <Link
              to="/detection"
              onClick={() => (window.location.href = "/detection")}
              className="block px-4 py-2 hover:bg-gray-100 hover:text-purple-700"
            >
             Anomaly Detection
            </Link>
          </li>
          <li>
            <Link
              to="/medical"
              onClick={() => (window.location.href = "/medical")}
              className="block px-4 py-2 hover:bg-gray-100 hover:text-purple-700"
            >
              Medical Coding
            </Link>
          </li>
        </ul>
      </li>

      {/* Wise Products Dropdown */}
      <li className="relative group">
        <Link
          to="/products"
          onClick={() => (window.location.href = "/products")}
          className="hover:text-purple-700 transition-colors duration-200"
        >
          Wise Products
        </Link>
        <ul
          className="absolute left-0 mt-2 w-48 bg-white text-black rounded shadow-lg opacity-0 invisible 
                     group-hover:opacity-100 group-hover:visible transition-all duration-200"
        >
          <li>
            <Link
              to="/his"
              onClick={() => (window.location.href = "/his")}
              className="block px-4 py-2 hover:bg-gray-100 hover:text-purple-700"
            >
              HIS
            </Link>
          </li>
          <li>
            <Link
              to="/ehr"
              onClick={() => (window.location.href = "/ehr")}
              className="block px-4 py-2 hover:bg-gray-100 hover:text-purple-700"
            >
              EHR
            </Link>
          </li>
          <li>
            <Link
              to="/rcm"
              onClick={() => (window.location.href = "/rcm")}
              className="block px-4 py-2 hover:bg-gray-100 hover:text-purple-700"
            >
              RCM
            </Link>
          </li>
          <li>
            <Link
              to="/lims"
              onClick={() => (window.location.href = "/lims")}
              className="block px-4 py-2 hover:bg-gray-100 hover:text-purple-700"
            >
              LIMS
            </Link>
          </li>
        </ul>
      </li>

      <li>
        <Link
          to="/contact"
          onClick={() => (window.location.href = "/contact")}
          className="hover:text-purple-700 transition-colors duration-200"
        >
          Contact Us
        </Link>
      </li>
    </ul>
  </nav>

</div>

    </header>
  );
};

export default Header;
